(function () {
  const form = document.getElementById('ContactForm');
  if (!form || form.dataset.contactConfirmReady === 'true') return;

  const inputStep = form.querySelector('[data-contact-step="input"]');
  const confirmStep = form.querySelector('[data-contact-step="confirm"]');
  if (!inputStep || !confirmStep) return;

  form.dataset.contactConfirmReady = 'true';

  const nameInput = form.querySelector('#ContactForm-name');
  const emailInput = form.querySelector('#ContactForm-email');
  const phoneInput = form.querySelector('#ContactForm-phone');
  const bodyInput = form.querySelector('#ContactForm-body');
  const confirmButton = form.querySelector('[data-contact-confirm]');
  const backButton = form.querySelector('[data-contact-back]');
  const emptyLabel = form.dataset.emptyValue || '—';

  function setStep(step) {
    const isConfirm = step === 'confirm';
    inputStep.hidden = isConfirm;
    confirmStep.hidden = !isConfirm;
    (isConfirm ? confirmStep : inputStep).scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  function fillConfirmStep() {
    const setValue = (key, value) => {
      const target = form.querySelector(`[data-contact-confirm-value="${key}"]`);
      if (target) target.textContent = value;
    };

    setValue('name', nameInput?.value.trim() || '');
    setValue('email', emailInput?.value.trim() || '');
    setValue('phone', phoneInput?.value.trim() || emptyLabel);
    setValue('body', bodyInput?.value.trim() || '');
  }

  confirmButton?.addEventListener('click', () => {
    if (!form.reportValidity()) return;
    fillConfirmStep();
    setStep('confirm');
  });

  backButton?.addEventListener('click', () => {
    setStep('input');
  });
})();
